import React, { useContext, useEffect, useMemo, useState } from 'react';
import cx from "classnames";
import { shallowEqual, useIntl, useSelector } from 'umi';
import { merge } from 'lodash-es';
import { Checkbox } from 'tea-component';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLanguage } from '@home/utils/common';
import { KEY_TYPE_MAP } from '@/pages/benchmark/_config/constant';
import { getExplainInfo, getMetricInfo } from '@/pages/benchmark/services/benchmark';
import './index.scss';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

const RadarChartCardTitle = (props: any) => {
  const { children, className, style, titleEn, titleCn, defaultActiveList, options, ...restProps } = props;
  const { locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;
  const { dataFrame } = useSelector((state: any) => ({
    dataFrame: state.dashboard?.currentGame?.data_frame || 'mobile',
  }), shallowEqual);
  const contextObj = useContext(FilterContext);
  const { filterVal = {} } = contextObj || {};
  const showCheck = filterVal?.compareType !== "game";
  const [activeList, setActiveList] = useState(defaultActiveList || []);
  const [explainMap, setExplainMap] = useState<any>({});
  const [metricMap, setMetricMap] = useState<any>({});

  const checkList = useMemo(() => options?.map((item: any) => ({
    name: getLanguage(isEN, item?.nameEn, item?.nameCn),
    value: item?.value
  })), [isEN, options]);

  const getExplainInfoData = () => {
    getExplainInfo().then((result: any) => {
      const explainMap: any = {};
      Object.keys(result)?.forEach((item) => {
        const key = KEY_TYPE_MAP?.[item] || item;
        const metricItem = result?.[item] || [];
        const obj: any = {};
        if (metricItem && metricItem?.length > 0) {
          metricItem?.forEach((v: { value: string; key: string | number; }) => {
            try {
              const value = JSON.parse(v?.value) || {};
              obj[v?.key] = value;
            } catch (error) {
              console.log(error);
            }
          });
        }
        explainMap[key] = obj;
      });
      setExplainMap(explainMap);
    }).catch((error: any) => {
      setExplainMap({});
      console.log(error);
    });
  };

  const getMetricInfoData = () => {
    getMetricInfo().then((result: any) => {
      const metricMap: any = {};
      result?.forEach((item: any) => {
        const { metric, metric_en: nameEn, metric_cn: nameCn, platform } = item || {};
        const key = KEY_TYPE_MAP?.[platform?.toLowerCase()] || platform?.toLowerCase();
        if (!metricMap?.[key]) {
          metricMap[key] = {};
          const metricObj = { ...item, nameEn, nameCn };
          metricMap[key][metric] = metricObj;
        } else {
          const metricObj = { ...item, nameEn, nameCn };
          metricMap[key][metric] = metricObj;
        }
      });
      setMetricMap(metricMap);
    }).catch((error: any) => {
      setMetricMap({});
      console.log(error);
    });
  };

  useEffect(() => {
    getExplainInfoData();
    getMetricInfoData();
  }, []);

  const metricConfig = useMemo(() => {
    const frameMap: any = {
      pc: 'pcconsole',
      mobile: 'mobile'
    };
    const frameType = frameMap?.[dataFrame || 'pc'];
    // pageConfig>七彩石>metricsConfig
    const explainInfo = explainMap?.[frameType] || {};
    const metricInfo = metricMap?.[frameType] || {};
    const metricConfig = merge(metricInfo, explainInfo);
    return metricConfig;
  }, [dataFrame, explainMap, metricMap]);

  return (<div className={cx(className)} style={style}>
    <div className="dbd-benchmark-card-title">
      <span className='dbd-benchmark-card-title-text'>{getLanguage(isEN, titleEn, titleCn)}</span>
      {
        showCheck && <Checkbox.Group value={activeList} onChange={(value: any) => setActiveList(value)}>
          {
            checkList.map((item: any) => <Checkbox key={item.value} name={item?.value}>{item.name}</Checkbox>)
          }
        </Checkbox.Group>
      }
    </div>
    {React.Children.map(children, (child: any) => React.cloneElement(
      child,
      {
        ...restProps,
        checkList,
        activeList,
        metricConfig,
        isEN,
        dataFrame,
        checkOptions: options,
        showCheck,
      }
    ))}
  </div>);
};

export default RadarChartCardTitle;